import { createReducer, createAction } from 'redux-starter-kit';

//TODO: use the constants for these
const showLoginPanel = createAction('SHOW_LOGIN_PANEL');
const hideLoginPanel = createAction('HIDE_LOGIN_PANEL');
const toggleActiveTab = createAction('TOGGLE_LOGIN_TAB');
const defaultState = { showLoginPanel: false, loginTabActive: true };

const rootReducer = createReducer(defaultState, {
  [showLoginPanel]: (state, action) => Object.assign({}, state, {showLoginPanel: true, loginTabActive: action.loginTabActive }),
  [hideLoginPanel]: (state, action) => Object.assign({}, state, {showLoginPanel: false }),
  [toggleActiveTab]: (state, action) => Object.assign({}, state, {loginTabActive: !action.active}),
  default:
    console.log('default root reducer..')
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/reducers.js